import { createFromIconfontCN } from "@ant-design/icons";

export default createFromIconfontCN({
  scriptUrl: "/iconfont/iconfont.js",
  //scriptUrl: "//at.alicdn.com/t/font_2320911_div6s31if17.js",
});

// import Icon from '@ant-design/icons'
//
// const IconRecording = () => (<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1809" width="16" height="16"><path d="M512 14.222222C237.084444 14.222222 14.222222 237.084444 14.222222 512s222.862222 497.777778 497.777778 497.777778 497.777778-222.862222 497.777778-497.777778S786.915556 14.222222 512 14.222222z m0 28.444445c259.202844 0 469.333333 210.130489 469.333333 469.333333s-210.130489 469.333333-469.333333 469.333333S42.666667 771.202844 42.666667 512 252.797156 42.666667 512 42.666667z" fill="#232323" p-id="1810"></path><path d="M512 512m-398.222222 0a398.222222 398.222222 0 1 0 796.444444 0 398.222222 398.222222 0 1 0-796.444444 0Z" fill="#232323" p-id="1811"></path></svg>)
//
// export default function IconFont() {
//   return <Icon component={IconRecording}  size={14}/>;
// }